module.exports = __webpack_public_path__ + "img/2_91.227d055a.png";